/* eslint-disable no-empty-pattern */
import React, { useEffect, useState } from 'react';
export var CountdownTimer = function (_a) {
    var minutes = _a.minutes;
    var _b = useState(minutes * 60), time = _b[0], setTime = _b[1];
    useEffect(function () {
        var interval = setInterval(function () {
            if (time > 0) {
                setTime(time - 1);
            }
            else {
                clearInterval(interval);
                // Timer has reached zero, do something (e.g., show a message)
            }
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [time]);
    var displayMinutes = Math.floor(time / 60);
    var displaySeconds = time % 60;
    return (React.createElement("span", null,
        React.createElement("span", null,
            displayMinutes.toString().padStart(2, '0'),
            ":"),
        React.createElement("span", null, displaySeconds.toString().padStart(2, '0'))));
};
//# sourceMappingURL=CountdownTimer.js.map